import { render, staticRenderFns } from "./npcFloat.vue?vue&type=template&id=3058553c&scoped=true&"
import script from "./npcFloat.vue?vue&type=script&lang=js&"
export * from "./npcFloat.vue?vue&type=script&lang=js&"
import style0 from "./npcFloat.vue?vue&type=style&index=0&id=3058553c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3058553c",
  null
  
)

export default component.exports